import React, { FC } from 'react'
import { IonModal, IonContent } from '@ionic/react'
import { observer } from 'mobx-react'
import { MyCardItem } from '@cps'
import './index.scss'

interface IProps {
  cover: IMemberCardInfo;
  covers: IMemberCardInfo[];
  reject?: () => void;
  resolve?: (data: IMemberCardInfo) => void;
}

const CardListModal: FC<IProps> = (props) => {
  const { covers, cover, reject, resolve } = props
  return (
    <IonModal
      cssClass='member-card-list-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss
      onDidDismiss={reject}
    >
      <IonContent onClick={reject}>
        <div className='modal-body'>
          {
            covers.map((item: IMemberCardInfo) => (
              <div data-cypid='mmgChooseMCard' className='card-block' key={item.cardId} onClick={(e: any) => { e.stopPropagation(); resolve(item) }}>
                <MyCardItem cardInfo={item} isOperate={false} onClick={() => { }}></MyCardItem>
                {cover.cardId === item.cardId && <div className='card-icon'><div className='icon-circle-block'><i className='iconfont icon-check'></i></div></div>}
              </div>
            ))
          }
        </div>
      </IonContent>
    </IonModal>
  )
}

export default observer(CardListModal)
